import React, { useEffect, useState } from 'react';
import { useHome } from '../../services/Firestore/Resources';
import { AnimatedNumber } from '../../components/AnimatedNumber/AnimatedNumber';
import { FairDate } from '../../services/Utils/Date';
import { AssetLink } from '../../components/Link/AssetLink/AssetLink';
import Paper from '../../components/Paper/Paper';
import { createUseStyles } from 'react-jss';
import { ManifestDraft, ManifestSent } from '../../constants';
import { ManifestTable } from '../../components/ManifestList/ManifestTable';
const useStyles = createUseStyles({
  hud: {
    display: 'grid',
    gridTemplateRows: '2fr auto auto auto',
  },
  header: {
    display: 'grid',
    gridTemplateColumns: 'auto auto auto',
  },
  alertNotification: {
    color: 'var(--alert-notification-color)',
    backgroundColor: 'var(--alert-notification-backgroundColor)',
    borderColor: 'var(--alert-notification-borderColor)',
  },
  alertWarning: {
    color: 'var(--alert-warning-color)',
    backgroundColor: 'var(--alert-warning-backgroundColor)',
    borderColor: 'var(--alert-warning-borderColor)',
  },
  alertDanger: {
    color: 'var(--alert-danger-color)',
    backgroundColor: 'var(--alert-danger-backgroundColor)',
    borderColor: 'var(--alert-danger-borderColor)',
  },
  alertTakeAction: {
    color: 'var(--alert-danger-color)',
    backgroundColor: 'var(--alert-danger-backgroundColor)',
    borderColor: 'var(--alert-danger-borderColor)',
    fontWeight: 'bold',
  },
  alertButtons: {
    position: 'relative',
    padding: '.75rem 1.25rem',
    marginBottom: '5px',
    border: '1px solid',
    textAlign: 'center',
    boxShadow: '1px 1px 3px #888',
    cursor: 'pointer',
  },
  alertView: {
    position: 'relative',
    padding: '.75rem 1.25rem',
    marginBottom: '5px',
    border: '1px solid',
    textAlign: 'left',
    boxShadow: '1px 1px 3px #888',
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    columnGap: '9px',
  },
  notificationPanel: {
    display: 'none',
  },
  newTable: {
    display: 'grid',
    gridTemplateColumns: '[col-start] auto [col-end]',
    gridTemplateRows: '[row-start] auto [row-end]',
    gridGap: '0px',

    border: '1px solid',
    textAlign: 'center',
    boxShadow: '1px 1px 3px #888',
    marginBottom: '10px',
  },
  heading: {
    fontWeight: 'bold',
    padding: '10px',
    position: 'relative',
  },
  title: {
    gridColumn: '1/8',
    fontWeight: 'bold',
    padding: '10px',
    textAlign: 'center',
    font: '400 20px sans-serif',
  },
  emptyRow: {
    gridColumn: '1/8',
    fontStyle: 'italic',
    padding: '10px',
    textAlign: 'center',
  },
  row: {
    padding: '10px',
    position: 'relative',
    zIndex: 2,
  },
  rowWrapper: {
    '&:hover div': {
      backgroundColor: 'var(--alert-notification-backgroundColor)',
      cursor: 'pointer',
    },
    display: 'contents',
  },
  menu: {
    justifyItems: 'center',
    display: 'grid',
    gridTemplateColumns: '180px 200px auto',
    textAlign: 'center',
  },
  storageLink: {
    cursor: 'pointer',
  },
  counter: {
    fontSize: '90px',
  },
  counterText: {
    fontSize: '40px',
    display: 'inline-block',
  },
  alertShortInfo: {
    paddingBottom: '20px',
  },
});

export default ({ myHome }) => {
  const [home, loading] = useHome(myHome.id);

  const [assets, setAssets] = useState([]);
  const [incomingManifests, setIncomingManifests] = useState([]);
  const [outgoingManifests, setOutgoingManifests] = useState([]);

  const [warnings, setWarnings] = useState([], [], []);
  const [oldOutgoingManifestsCount, setOldOutgoingManifestsCount] = useState(0);
  const [oldIncomingManifestsCount, setOldIncomingManifestsCount] = useState(0);

  useEffect(() => {
    if (!loading) {
      let storageIdsToUse = home.departmentIds;
      if (myHome.departmentId) {
        //Only show department
        storageIdsToUse = [myHome.departmentId];
      }
      setAssets(home.getAssetsCategorized(storageIdsToUse));
      setIncomingManifests(home.getIncomingManifests(storageIdsToUse));
      setOutgoingManifests(home.getOutgoingManifests(storageIdsToUse));
    }
  }, [home, loading, myHome.departmentId]);

  useEffect(() => {
    const prepareWarnings = () => {
      // processer warnings etc.

      let warningList = [];
      let dangerList = [];
      let notificationList = [];
      let timeNow = new Date();
      const day = 86400000;

      if (assets.expiredAssets && assets.expiredAssets.length > 0) {
        for (const asset of assets.expiredAssets) {
          if (asset.calibrationDate) {
            dangerList.push(
              <React.Fragment key={asset.id}>
                <AssetLink {...asset} />
                <div> expired {FairDate(asset.calibrationDueDate.toDate())}</div>
              </React.Fragment>,
            );
          } else {
            dangerList.push(
              <React.Fragment key={asset.id}>
                <AssetLink {...asset} />
                <div> Not calibrated</div>
              </React.Fragment>,
            );
          }
        }
      }

      if (assets.expiringAssets && assets.expiringAssets.length > 0) {
        for (const asset of assets.expiringAssets) {
          var days = Math.trunc(
            (asset.calibrationDueDate.toDate().getTime() - timeNow.getTime()) / day,
          );
          warningList.push(
            <React.Fragment key={asset.id}>
              <AssetLink {...asset} />
              <div>
                {' '}
                will expire in {days} days at {FairDate(asset.calibrationDueDate.toDate())}
              </div>
            </React.Fragment>,
          );
        }
      }
      if (assets.rentalAssets && assets.rentalAssets.length > 0) {
        for (const asset of assets.rentalAssets) {
          notificationList.push(
            <React.Fragment key={asset.id}>
              <AssetLink {...asset} />
              <div>rented by {asset.owner}</div>
            </React.Fragment>,
          );
        }
      }
      setWarnings({ warningList, dangerList, notificationList });
    };

    prepareWarnings();
  }, [assets]);

  useEffect(() => {
    const checkIfOldManifests = () => {
      setOldIncomingManifestsCount(countOldManifestsWithState(incomingManifests, ManifestSent, 60));
      setOldOutgoingManifestsCount(
        countOldManifestsWithState(outgoingManifests, ManifestDraft, 60),
      );
    };

    checkIfOldManifests();
  }, [incomingManifests, outgoingManifests]);

  const classes = useStyles();
  const [show, setShow] = useState('header');

  function toggleInfo(colour) {
    if (show === colour) {
      setShow('header');
    } else {
      setShow(colour);
    }
  }

  if (loading) {
    return <p>Loading...</p>;
  }

  function goToHomeStorage() {
    window.location = myHome.departmentId
      ? 'storages/' + myHome.departmentId
      : 'storages/' + myHome.id;
  }

  /* Manifest Functions*/

  //Counts manifests older than x days with specified state.
  function countOldManifestsWithState(manifestList, state, days) {
    let timeNow = new Date();
    let timeNowInSeconds = timeNow.getTime();
    if (manifestList.length > 0) {
      return manifestList.filter(
        (manifest) =>
          manifest.stateUpdated.seconds * 1000 < timeNowInSeconds - days * 86400000 &&
          manifest.state === state,
      ).length;
    }
    return 0;
  }

  return (
    <div>
      {/* Alerts Section */}
      <div>
        {
          <>
            <div className={classes.menu}>
              <div className={classes.storageLink} onClick={goToHomeStorage}>
                <div className={classes.counter}>
                  <AnimatedNumber value={assets.count ? assets.count : 0} />
                </div>
                <div className={classes.counterText}>assets</div>
              </div>
              <div className={classes.alertShortInfo}>
                {Object.keys(warnings.warningList).length > 0 && (
                  <div
                    className={classes.alertButtons + ' ' + classes.alertWarning}
                    onClick={() => {
                      toggleInfo('warning');
                    }}
                  >
                    {Object.keys(warnings.warningList).length} up for calibration
                  </div>
                )}
                {Object.keys(warnings.dangerList).length > 0 && (
                  <div
                    className={classes.alertButtons + ' ' + classes.alertDanger}
                    onClick={() => {
                      toggleInfo('alert');
                    }}
                  >
                    {Object.keys(warnings.dangerList).length} out of calibration
                  </div>
                )}
                {Object.keys(warnings.notificationList).length > 0 && (
                  <div
                    className={classes.alertButtons + ' ' + classes.alertNotification}
                    onClick={() => {
                      toggleInfo('notification');
                    }}
                  >
                    {Object.keys(warnings.notificationList).length} rentals
                  </div>
                )}
              </div>
              <div>
                <>
                  {' '}
                  {show === 'header' && (
                    <div className={classes.counterText}>
                      {myHome.departmentName ? home.name + ' ' + myHome.departmentName : home.name}
                    </div>
                  )}
                  <div
                    className={
                      show === 'warning'
                        ? classes.alertView + ' ' + classes.alertWarning
                        : classes.notificationPanel
                    }
                  >
                    {warnings.warningList}
                  </div>
                  <div
                    className={
                      show === 'alert'
                        ? classes.alertView + ' ' + classes.alertDanger
                        : classes.notificationPanel
                    }
                  >
                    {warnings.dangerList}
                  </div>
                  <div
                    className={
                      show === 'notification'
                        ? classes.alertView + ' ' + classes.alertNotification
                        : classes.notificationPanel
                    }
                  >
                    {warnings.notificationList}
                  </div>
                </>
              </div>
            </div>
          </>
        }
      </div>

      {/* Manifests section */}
      <Paper style={{ padding: '10px' }}>
        <div>
          {oldIncomingManifestsCount > 0 && (
            <div className={classes.alertView + ' ' + classes.alertTakeAction}>
              You have {oldIncomingManifestsCount} incoming manifests that are older than 2 months.
              Please receive them.
            </div>
          )}
          {oldOutgoingManifestsCount > 0 && (
            <div className={classes.alertView + ' ' + classes.alertTakeAction}>
              You have {oldOutgoingManifestsCount} outgoing manifests that are older than 2 months
              and not sent. Please send them.
            </div>
          )}
        </div>
        <div>
          <h2>
            Incoming manifests <AnimatedNumber value={incomingManifests.length} />
          </h2>
          <ManifestTable manifests={incomingManifests} />
        </div>
        <div>
          <h2>
            Outgoing manifests <AnimatedNumber value={outgoingManifests.length} />
          </h2>
          <ManifestTable manifests={outgoingManifests} />
        </div>
      </Paper>
    </div>
  );
};
